import type { PopupPositionsType } from "@skbkontur/react-ui";

export const pinTourStep = {
    id: "candyform_pin",
    onBefore: "showPanel",
    onAfter: "hidePanel",
    header: "Сворачивание меню",
    content: "Нажмите на булавку, чтобы «открепить» меню: оно свернется и не будет занимать место.",
    positions: ["bottom left"] as PopupPositionsType[],
    group: ["panel"],
    order: 35,
    offset: 20,
};
